define('views/conversations/Podio.Views.Conversations.Chat.People',['require','translate','underscore','jquery','lib/backbone/Backbone.PodioView','models/Podio.Models.User','lib/Podio.UI','lib/Podio.UI.AutoCompleter','lib/Podio.Transport','lib/Podio.Routes','lib/Podio.Utils','jst!conversations/chat/_people_list_empty','jst!conversations/chat/_people_main','jst!conversations/chat/_people_list_item'],function(require) {

  var t = require('translate');
  var _ = require('underscore');
  var $ = require('jquery');
  var PodioView = require('lib/backbone/Backbone.PodioView');
  var ModelUser = require('models/Podio.Models.User');
  var podioUI = require('lib/Podio.UI');
  var keyCodes = podioUI.KeyCodes;
  var AutoCompleter = require('lib/Podio.UI.AutoCompleter');
  var transport = require('lib/Podio.Transport');
  var routes = require('lib/Podio.Routes');
  var podioUtils = require('lib/Podio.Utils');

  var jstPeopleListEmpty = require('jst!conversations/chat/_people_list_empty');
  var jstPeopleMain = require('jst!conversations/chat/_people_main');
  var jstPeopleListItem = require('jst!conversations/chat/_people_list_item');

  return PodioView.extend({
    podioEvents: {
      'click .new-conversation'             : 'onNewConversationClicked',
      'keydown default #chat_people_search' : 'onSearchFieldKeydown',
      'input default #chat_people_search'   : 'onSearchFieldInput'
    },

    initialize: function() {

      this._super();
      _.bindAll(this, 'onSearchFieldInput', 'onAutoCompleteItemSelected', 'onNewConversationClicked');
    },

    _getAutoCompleteData : function(query) {
      var dfd = new $.Deferred();

      var target = 'conversation_presence';
      var querystring = { 'target': target, 'limit': 14 };
      var reqUrl = routes.autocomplete_reference_picker_path(querystring);

      var req = transport.cachedRequest('get', 'json', reqUrl, {
        abortable: true,
        storeKey :'autocomplete_' + target,
        requestKey : query ? 'search_{0}'.format(query) : 'top',
        requestData : {'query': query}
      });

      req.done(function(responseData) {
        if ( responseData.data.items ) {
          dfd.resolve( responseData.data.items );
        }
      });

      return dfd;
    },

    _populateAutoCompleteData: function(query) {
      var self = this;
      this.autoCompleter.renderLoading();

      $.when( this._getAutoCompleteData(query) ).then(function(data) {

        if (!data.length) {
          self.autoCompleter.renderEmpty();
          self.autoCompleter.elmAutocompleteList.append(self.getTemplate(jstPeopleListEmpty, {
            query: query,
            translations: {
              no_search_results: t('No search results #conversations.chat'),
              send_message: t('Send a message to add people to your contacts #conversations.chat')
            }
          }));
          return;
        }

        self.autoCompleter.populate( data, query );
      });

    },

    _initAutoCompleter: function() {
      this.autoCompleter = new AutoCompleter(this.elmContainer.find('.people-list'), {
        selectFirstItem: false,
        templates: {
          wrapper       : _.template('<div></div>'),
          list          : _.template('<ul></ul>'),
          item          : jstPeopleListItem,
          group         : $.noop
        }
      } );

      this.autoCompleter.hide = $.noop; // Don't allow auto completer to hide itself
      this.autoCompleter.signals.onItemSelected.add(this.onAutoCompleteItemSelected);

      this._populateAutoCompleteData('');
    },

    _initSearchField: function() {
      this.elmSearchField = this.elm.find('#chat_people_search');
    },

    onSearchFieldKeydown: function(elmTarget, e) {

      if (e.which === keyCodes.Esc && this.elmSearchField.val().length === 0) {
        e.preventDefault();
        e.stopPropagation();
        this.eventBus.trigger('chatMainView:closeChatPane');
        this.elmSearchField.blur();
      }

      if (e.which === keyCodes.UpArrow || e.which === keyCodes.DownArrow) {
        e.preventDefault();

        var elmPeopleListItems = this.elm.find('.people-list ul li');
        var elmSelectedItem = this.autoCompleter.selectedItem;
        var elmNextSelectedItem;

        if (e.which === keyCodes.UpArrow) {
          if (!elmSelectedItem || elmSelectedItem && !elmSelectedItem.get(0).previousSibling) {
            elmNextSelectedItem = elmPeopleListItems.last();
          } else {
            elmNextSelectedItem = elmSelectedItem.prev();
          }
        }

        if (e.which === keyCodes.DownArrow) {
          if (!elmSelectedItem || elmSelectedItem && !elmSelectedItem.get(0).nextSibling) {
            elmNextSelectedItem = elmPeopleListItems.first();
          } else {
            elmNextSelectedItem = elmSelectedItem.next();
          }
        }

        this.autoCompleter.selectItem(elmNextSelectedItem);
      }

      if (e.which === keyCodes.Return) {
        if (this.autoCompleter.selectedItem) {
          this.autoCompleter.selectCurrentItem(this.autoCompleter.selectedItem, e);
        }
      }

    },

    onSearchFieldInput: function(elmTarget, e) {
      var query = this.elmSearchField.val();
      this._populateAutoCompleteData(query);
    },

    onAutoCompleteItemSelected: function(item) {
      switch (item.ref_type) {
      case 'user':
        var user = new ModelUser(_.pick(item, 'id', 'name', 'link'));
        user.set('user_id', user.get('id'));

          // HACK: Set the thumbnail link to the base image url unless it's the default avatar
        if (item.itemIcon.indexOf('defaultavatar') === -1) {
          user.set('image', { thumbnail_link: item.itemIcon.replace('/small', '') });
        }

        this.eventBus.trigger('chatPeopleView:userSelected', user);
        break;
      default:
        throw 'Unhandled ref_type "' + item.ref_type + "' for selected item";
      }
    },

    onNewConversationClicked: function(targetElm, event) {
      this.eventBus.trigger('newConversation:click');
    },

    render: function(options) {
      this.elm.html(this.getTemplate(jstPeopleMain, {
        translations: {
          find_someone: t('Search connections #contact_app_type'),
          close: t('Close #chatpane'),
          new_message: t('New message #chatpane')
        }
      }));
      this.elmContainer = this.elm.find('#chat-people-container');

      this._initAutoCompleter();
      this._initSearchField();

      return this;
    },

    dispose: function() {
      this.elmSearchField.unbind('input', this.onSearchFieldInput);
    },

    focusSearchField: function() {
      var self = this;
      _.defer(function() {
        self.elmSearchField.focus();
      });
    }
  });

});

